import './app.js'

import cookie from 'cookie'

const cookie_name = 'cookieSettings'

const settings = [
  'analitycs',
  'social',
  'tecnical',
]

const form = document.getElementById( 'cookie-settings' )

form.addEventListener( 'submit', e => e.preventDefault() )
form.addEventListener( 'change', e => {

  let data = {}
  settings.forEach( setting => {
    data[ setting ] = form.elements[setting].checked
  })

  const expires = new Date()
  expires.setFullYear( expires.getFullYear() + 1 )

  document.cookie = cookie.serialize( cookie_name, JSON.stringify( data ), {
    expires,
  })
})

let cookieStatus = cookie.parse( document.cookie )[ cookie_name ]
if( cookieStatus )
{
  let cookieStatusObject = {}

  if( cookieStatus == 'yes' )
  {
    settings.forEach( setting => cookieStatusObject[ setting ] = true )
  }
  else
  {
    cookieStatusObject = JSON.parse( cookieStatus )
  }

  for( let c in cookieStatusObject )
  {
    form.elements[ c ].checked = cookieStatusObject[ c ]
  }

}
